const INVALID_FILENAME_CHARS = /[\\/:*?"<>|]/g

export function getAlbaranShortId(order) {
  if (order?.idTucomida) return String(order.idTucomida)
  if (order?.idT) return String(order.idT)
  if (order?._id) return String(order._id).slice(-6)
  if (order?.id) return String(order.id).slice(-6)
  return 'N/A'
}

/** Misma lógica que la columna deliveryDate en /account/ */
export function formatAlbaranDeliveryDate(order) {
  const value = order?.deliveryDate
  if (value == null || value === '') return ''

  if (typeof value === 'string') {
    return value.split(',')[0].trim()
  }

  const date = new Date(value)
  if (!Number.isNaN(date.getTime())) {
    return date.toLocaleDateString()
  }

  return ''
}

function sanitizeFilenamePart(value, fallback) {
  const cleaned = String(value ?? '')
    .trim()
    .replace(INVALID_FILENAME_CHARS, '')
    .replace(/\s+/g, '_')

  return cleaned || fallback
}

function sanitizeDeliveryDatePart(value) {
  return String(value ?? '')
    .trim()
    .replace(INVALID_FILENAME_CHARS, '')
    .replace(/\s+/g, '_')
    .replace(/\//g, '-')
}

/** Nombre de archivo al descargar albarán: TradeName_fecha_Id.pdf */
export function buildAlbaranFilename(order, tradeNameFallback) {
  const tradeName = sanitizeFilenamePart(
    order?.tradeName || order?.userAcc?.tradeName || tradeNameFallback,
    'ALBARAN',
  )
  const shortId = sanitizeFilenamePart(getAlbaranShortId(order), 'N/A')
  const deliveryDate = sanitizeDeliveryDatePart(formatAlbaranDeliveryDate(order))
  const datePart = deliveryDate ? `${deliveryDate}_` : ''

  return `${tradeName}_${datePart}${shortId}.pdf`
}
